// Build58 benefitQueries intent, mapped to the web's actual author-bearing caches.
// Never patch arbitrary cached objects by nickname: refetch authoritative profile marks.
const roots = new Set([
  'me',
  'user',
  'users',
  'userContent',
  'publicMusicRecords',
  'myMusicRecords',
  'publicTaste',
  'musicRecordsSearch',
  'support',
  'sponsorships',
  'badges',
  'reviews',
  'review',
  'comments',
  'reviewComments',
  'playlistComments',
  'albumReviews',
  'album-review-history',
  'browse-reviews',
  'reviewsAlbums',
  'home',
  'discovery',
  'playlists',
  'playlist',
  'albums',
  'album',
  'feeds',
  'feed',
  'web-discovery',
  'web-members',
  'web-following',
  'web-reviewer-candidates',
  'web-member-reviews',
  'web-divided-album',
  'web-recent-review-check',
  'browse-playlists',
  'browse-my-playlists',
  'browse-curator',
  'browse-artist-playlists',
  'web-search-results',
  'web-search-category-page',
  'web-search-bridge',
]);
export function benefitQuery(key) {
  const [root, section] = key;
  if (root === 'web-parity') return section === 'explore' || section === 'recent-reviews';
  if (root === 'artist-full-view') return key[4] === 'included-playlists';
  if (!roots.has(root)) return false;
  if (root === 'playlist' && ['preview-images', 'auto-artwork'].includes(section)) return false;
  if (root === 'home' && ['explicit-rating', 'event-ads', 'track-previews'].includes(section))
    return false;
  return true;
}
export function refreshBenefitQueries(client, preservedKey) {
  return client.invalidateQueries({
    predicate: (q) =>
      benefitQuery(q.queryKey) &&
      (!preservedKey || JSON.stringify(q.queryKey) !== JSON.stringify(preservedKey)),
  });
}
